/* EmojiRadioButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./EmojiRadioButton.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { memo, forwardRef } from 'react';
import { B100 } from '@atlaskit/theme/colors';
import { leftClick } from '../../util/mouse';
import Emoji from './Emoji';
import { TONESELECTOR_KEYBOARD_KEYS_SUPPORTED } from '../../util/constants';
import VisuallyHidden from '@atlaskit/visually-hidden';
var emojiButton = null;
var emojiRadio = null;
var handleMouseDown = function handleMouseDown(props, event) {
  var onSelected = props.onSelected;
  event.preventDefault();
  if (onSelected && leftClick(event)) {
    onSelected();
  }
};
var handleKeyPress = function handleKeyPress(props, event) {
  if (TONESELECTOR_KEYBOARD_KEYS_SUPPORTED.includes(event.key)) {
    var onSelected = props.onSelected;
    event.preventDefault();
    event.stopPropagation();
    if (onSelected) {
      onSelected();
    }
  }
};
export var EmojiRadioButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var emoji = props.emoji,
    selectOnHover = props.selectOnHover,
    ariaLabelText = props.ariaLabelText,
    defaultChecked = props.defaultChecked;
  return /*#__PURE__*/React.createElement("label", {
    onMouseDown: function onMouseDown(event) {
      return handleMouseDown(props, event);
    },
    onKeyDown: function onKeyDown(event) {
      return handleKeyPress(props, event);
    },
    className: ax(["_19itidpf _2rkosqtm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _80omtlke _kqswh2mm _1e0c1o8l _lev4idpf _1cx6idpf _tyukidpf _2ewlidpf _11bcidpf _dqozglyw _1at812x7 _1cjo12x7 _1yg612x7 _hjaq12x7 _hlt21tcg _1s3c1tcg _1i911tcg _1ye71tcg _nt751r31 _49pcglyw _1hvw1o36 _7ehi1r2v _491113zc"]),
    style: {
      "--_1rebzxw": ix("0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")))
    }
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, ariaLabelText), /*#__PURE__*/React.createElement("input", {
    ref: ref,
    "data-testid": ariaLabelText,
    type: "radio",
    name: "skin-tone",
    defaultChecked: defaultChecked,
    className: ax(["_tzy4idpf _kqswstnw _154i14id _1ltv14id _3y8msqtm _157z1r31 _1dzmglyw _1sqm1o36 _fh6w1r2v _1i1213zc"]),
    style: {
      "--_1rebzxw": ix("0 0 0 2px ".concat("var(--ds-border-focused, ".concat(B100, ")")))
    }
  }), /*#__PURE__*/React.createElement(Emoji, {
    emoji: emoji,
    selectOnHover: selectOnHover,
    shouldBeInteractive: false,
    "aria-hidden": true
  }));
});
export default /*#__PURE__*/memo(EmojiRadioButton);